import {SurveySessionState} from "./SurveySessionModel";

export enum SurveyCampaignState {
    pending = "pending",
    executing = "executing",
    completed = "completed",
    cancelled = "cancelled",
    error = "error",
}

export interface SurveyCampaignModel  {
    id: string;
    state: SurveyCampaignState;
    form: SurveyCampaignFormModel;
    startDate: Date;
    endDate?: Date;
    name?: string;
    comment?: string;
    isTest: boolean;
    isForAll: boolean;
    specialGroupIds?: string[];
    patientIds?: string[];
    participantsCount: number;
    participantsWithAnswersCount: number;
}

export interface SurveyCampaignFormModel {
    id: string;
    name: string;
}

export function SurveyCampaignStateToString(state: SurveyCampaignState): string {
    switch (state) {
        case SurveyCampaignState.pending:
            return "Ожидание";
        case SurveyCampaignState.executing:
            return "Выполняется";
        case SurveyCampaignState.cancelled:
            return "Отменена";
        case SurveyCampaignState.completed:
            return "Завершена";
        case SurveyCampaignState.error:
            return "Ошибка";
    }

}
